// dataset uuid 집합을 불변으로 다루는 helper(목록 선택·북마크·생성 진행 상태 등 공용).

export function includesDatasetUuid(datasetUuids: readonly string[], datasetUuid: string): boolean {
  return datasetUuids.includes(datasetUuid);
}

export function addDatasetUuid(
  datasetUuids: readonly string[],
  datasetUuid: string,
): readonly string[] {
  return datasetUuids.includes(datasetUuid) ? datasetUuids : [...datasetUuids, datasetUuid];
}

export function removeDatasetUuid(
  datasetUuids: readonly string[],
  datasetUuid: string,
): readonly string[] {
  return datasetUuids.filter((currentUuid) => currentUuid !== datasetUuid);
}
